import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AlertService, ContactFormService,AppService } from '../_services/index';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styles: []
})
export class ContactFormComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; 
  dtTrigger = new Subject(); 
  contactFormList: any[] = []; 
  closeResult: string; 

  constructor(
      public router: Router,
      private dataService:ContactFormService,
      private alertService: AlertService,
      private AppService: AppService,
      private modalService: NgbModal
  ) { }

  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);
    this.allContactForm();
  }

  allContactForm(){
    this.loadShow();
    this.dataService.getContactFormData()
        .pipe().subscribe(
          data => { this.contactFormList = data['data'];
          this.dtTrigger.next();          
          this.loadHide();
        });
      }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

}
